import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { VueFinalModal, useVfm } from 'vue-final-modal';
import UserForm from './UserForm.vue';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalUser',
    setup(__props) {
        const vmf = useVfm();
        const handleCloseModal = () => {
            vmf.closeAll();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VueFinalModal), {
                class: "confirm-modal",
                "content-class": "confirm-modal-content",
                "overlay-transition": "vfm-fade",
                "content-transition": "vfm-fade"
            }, {
                default: _withCtx(() => [
                    _createVNode(UserForm, { onCloseModal: handleCloseModal })
                ]),
                _: 1
            }));
        };
    }
});
